import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import media from '../../styles/media.style';
import Image from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';
import { PAGE_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const DiscoverSection = styled.section`
  margin: 0 auto;
  max-width: ${PAGE_WIDTH}px;

  ${media.tabletP`
    display: flex;
  `};
`;

const CTA = styled.div`
  background-color: ${({ dark }) => (dark ? '#333' : '#f2f2f2')};
  width: 100%;

  ${media.tabletP`
    width: 50%;
  `};
`;

const Details = styled.div`
  align-items: center;
  color: ${({ dark }) => (dark ? 'white' : 'black')};
  display: flex;
  flex-direction: column;
  height: 150px;
  justify-content: center;
  padding: ${MOBILE_PADDING}px;

  ${media.tabletL`
    height: 250px;
  `};
`;

const Description = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.14;
  text-align: center;
  width: 100%;

  ${media.tabletL`
    font-size: 28px;
    line-height: 1.33;
    letter-spacing: 0.1px;
    max-width: 390px;
  `};
`;

const Discover = ({ cta1, cta2, locale }) => (
  <DiscoverSection>
    <CTA id="our-heritage-section">
      <Link href={`/${locale}${cta1.url}`} to={`/${locale}${cta1.url}`}>
        {cta1.image ? (
          <Image src={cta1.image} options={{ size: [600, 450, 600, 720] }} />
        ) : (
          <Placeholder w="100%" pb="calc(250% / 3)" />
        )}
        <Details>
          <Description>{cta1.description || <Placeholder w="100%" h="50px" />}</Description>
        </Details>
      </Link>
    </CTA>

    <CTA id="our-assets-section" dark>
      <Link href={`/${locale}${cta2.url}`} to={`/${locale}${cta2.url}`}>
        {cta2.image ? (
          <Image src={cta2.image} options={{ size: [600, 450, 600, 720] }} />
        ) : (
          <Placeholder w="100%" pb="calc(250% / 3)" />
        )}
        <Details dark>
          <Description>{cta2.description || <Placeholder w="100%" h="50px" />}</Description>
        </Details>
      </Link>
    </CTA>
  </DiscoverSection>
);

Discover.defaultProps = {
  cta1: {},
  cta2: {},
};

Discover.propTypes = {
  cta1: PropTypes.shape(),
  cta2: PropTypes.shape(),
  locale: PropTypes.string.isRequired,
};

const mapState = state => ({
  locale: state.locale,
});

export default connect(mapState)(Discover);



// WEBPACK FOOTER //
// ./src/pages/AboutPage/DiscoverSection.js